import createClient from 'openapi-fetch'
import { withErrorCapture } from '@omnea-app/legacy/utils/general/observability/withErrorCapture'
import { ServiceUrls } from '@omnea-app/legacy/utils/general/serviceUrls'
import { paths } from './tasksGeneratedTypes'

interface Params {
  authorization: string
}

export type Task = paths['/']['post']['responses']['200']['content']['application/json']['tasks'][number]

export class TasksHttpClient {
  GET
  POST
  constructor({ authorization }: Params) {
    const { GET, POST } = createClient<paths>({
      baseUrl: ServiceUrls.TASKS,
      headers: { Authorization: authorization },
    })
    this.GET = withErrorCapture({ method: GET })
    this.POST = withErrorCapture({ method: POST })
  }
}
